export default "__VITE_ASSET__DrT_Hq7V__";